import { ref } from 'vue';
import { useStore } from 'vuex';
import { useRuntimeEnv } from './useRuntimeEnv';
import { AxiosInstance, AxiosStatic } from 'axios';
import { createSharedComposable } from '@vueuse/core'

let _interceptorInstalled = false;

const useSharedState = createSharedComposable(() => {
  const errorMsg = ref('');

  return {
    errorMsg,
  };
});

export function useSearchErrorNotifier(axiosInstance: AxiosInstance | AxiosStatic) {
  const store = useStore();
  const env = useRuntimeEnv();

  const _hubSearchBaseUrl = env.api.baseUrl;

  function notifyError(error: string) {
    store.dispatch('snackbar/showSnackbar', { message: error, variant: 'error' });
  }

  const { errorMsg } = useSharedState();


  function installInterceptor() {
    if (_interceptorInstalled)
      return;
    _interceptorInstalled = true;

    // Intercept only hub search requests; notify all errors
    // message template: "Ein Netzwerkfehler ist aufgetreten. {error.message}"
    axiosInstance.interceptors.response.use(
      response => response,
      error => {
        if (error?.config?.url?.startsWith(_hubSearchBaseUrl)) {
          const message = `Ein Fehler ist aufgetreten: "${error?.message}"`;
          errorMsg.value = message;
          notifyError(message);
        }
        return Promise.reject(error);
      }
    );
  }

  return {
    errorMsg,
    notifyError,
    installInterceptor,
  };
}
